(ns renderer6.music-sticker-constants
  "Layout constants of the native Instagram music sticker visuals that
   both the editor previews (storrito.editor.music-sticker) and the
   renderer (renderer6.music-sticker) need, so that the editor and the
   rendered story media stay WYSIWYG. All values are measured from
   stories that were posted with the Instagram app (soul.globe,
   2026-08-19, 720x1280 output) — see docs/music-sticker.md for the
   measurement details.")

(def waveform
  "The animated waveform glyph of the album-art and simple music
   stickers: a bouncing equalizer with sinusoidally oscillating capsule
   heights (330x330, 35 frames, one seamless loop, VP9 with alpha).
   Served as a static file by the app-server; the editor composition
   plays it over the rasterized sticker exactly like renderer6 bakes it
   into the story media."
  {:uri "/img/music-waveform-bounce.webm"
   :file-name "music-waveform-bounce.webm"})

(def vinyl
  "MUSIC_VINYL: the disc is a square with the sticker's full width at
   the top; the label diameter is :label-ratio of that width. The
   record rotates at exactly 36 deg/s, i.e. one full rotation every
   :rotation-seconds. :disc-uri is the rotating record itself (the
   groove annulus without cover art and background, extracted from an
   Instagram-app story as a video with alpha; one seamless 10 s
   rotation, 30 fps), served as a static file by the app-server. In
   that video the disc's outer edge sits at radius 350.5 of the 704 px
   frame (the rest is transparent margin), so the frame must be scaled
   by :disc-frame-ratio to cover the disc."
  {:label-ratio 0.56
   :rotation-seconds 10
   :disc-uri "/img/music-vinyl-disc.webm"
   :disc-file-name "music-vinyl-disc.webm"
   :disc-frame-ratio (/ 704.0 701.0)})

(def album-art
  "MUSIC_OVERLAY_ALBUM_ART: a translucent dark badge with the animated
   waveform glyph sits in the lower-left corner of the square cover,
   :badge-ratio wide/high and inset :badge-inset-ratio from the cover's
   left and bottom edge. Ratios of the sticker width, which equals the
   cover width."
  {:badge-ratio 0.2431
   :badge-inset-ratio 0.0545})

(def simple
  "MUSIC_OVERLAY_SIMPLE: the card width varies with the text length;
   the cover thumbnail is a square of the card height minus twice
   :thumb-inset-ratio, so its center sits at half the card height on
   both axes. Ratios of the card height."
  {:thumb-inset-ratio 0.107})
